import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 0c-198.144 0-358.4 160.256-358.4 358.4 0 268.8 358.4 665.6 358.4 665.6s358.4-396.8 358.4-665.6c0-198.144-160.256-358.4-358.4-358.4zM512 486.4c-70.656 0-128-57.344-128-128s57.344-128 128-128c70.656 0 128 57.344 128 128s-57.344 128-128 128z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPin);
export default ForwardRef;
